// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CheckBox_wrapper__3ymMI","icon":"CheckBox_icon__en4kc","isChecked":"CheckBox_isChecked__3ezgu"};